module.exports = __webpack_public_path__ + "static/media/shield.7cedeb31.svg";